import FundUpdateView from './FundUpdateView'

export default FundUpdateView